export default __webpack_public_path__ + "static/media/instagram.aaf5c6d1.png";